/** 正则表达式 */
/** 手机 */
export const phoneReg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
/** 邮编 */
export const postCode = /^[0-9][0-9]{5}$/

export const pwdReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/

/** 数字 */
export const numberReg = /^(\d+)$/

function required(data = '必须输入') {
    return [
        {
            required: true,
            trigger: 'blur',
            message: data
        }
    ]
}

function min(min = 6, type = '密码') {
    return [
        {
            min,
            message: `${type}长度不小于${min}位`,
            trigger: 'blur'
        }
    ]
}

function pattern(reg, message, trigger = 'blur') {
    return [
        {
            pattern: reg,
            message,
            trigger
        }
    ]
}

/** 必填 */
export const requiredInput = data => {
    return required(data)
}

/**
 * 验证手机号
 */
export const phone = () => {
    const valid = required('请输入手机号')
    // 测试期间注释本句代码
    // valid = valid.concat(pattern(phoneReg, '手机号格式不正确'))
    return valid
}

/**
 * 数字
 */
export const isNumber = msg => {
    let valid = required('价格不能为空')
    valid = valid.concat([
        {
            type: 'number',
            trigger: 'change',
            message: msg,
            transform(value) {
                return Number(value)
            }
        }
    ])
    return valid
}

/**
 * 密码验证
 */
export const password = () => {
    let valid = required('请输入密码')
    valid = valid.concat(min()).concat(pattern(pwdReg, '密码需由数字和字母组成，至少6位'))
    return valid
}

/**
 * 登录密码验证
 */
export const oldPassword = () => {
    let valid = required('请输入密码')
    valid = valid.concat(min())
    return valid
}
/**
 * @type {Array}
 */
// 请至少输入10个字，说明原因
export const reasonsInput = (min = 10, max = 250, ev = 'blur') => [{ required: true, message: `请填写至少${min}个字符`, trigger: ev }, { min, message: `请填写至少${min}个字符`, trigger: 'change' }, { max, message: `字符不能超过${max}个`, trigger: 'change' }]

/**
 * @type {Array}
 */
// 最多输入50字符
export const maxInput = (name, max = 50) => [{ required: true, message: `${name}不能为空`, trigger: 'change' }, { max, message: `字符不能超过${max}个`, trigger: 'change' }]

/**
 * @type {Array}
 */
// 最多输入50字符
export const maxInputNotRequire = (max = 50) => [{ max, message: `字符不能超过${max}个`, trigger: 'change' }]

/**
 * @type {Array}
 */
// 验证坐在地区长度
export const validateArea = (rule, value, callback) => {
    if (value && value.length < 2) {
        callback(new Error('所在地区填写不完整'))
    } else {
        callback()
    }
}
/**
 * 验证手机号
 * @type {Array}
 */
export const phoneNumInput = [{ required: true, message: '请输入手机号', trigger: 'change' }, { pattern: phoneReg, message: '手机号格式不正确', trigger: 'change' }]
/**
 * 验证邮编
 * @type {Array}
 */
export const validatePostCode = [{ required: true, message: '请输入邮编', trigger: 'change' }, { pattern: /^[0-9][0-9]{5}$/, message: '邮编格式不正确', trigger: 'change' }]
/**
 * 验证邮箱
 * @type {Array}
 */
export const mail = [{ required: true, message: '邮箱不能为空', trigger: 'change' }, { type: 'email', message: '邮箱格式不正确', trigger: 'change' }]

/**
 * 注册步骤下拉框所属分中心必填校验
 * @type {Array}
 */
 export const ssfzxJy = [{ required: true, message: '请选取所属分中心', trigger: 'change' }]